import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown-container" }
const _hoisted_2 = { value: 'all' }
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      class: "dropdown-select",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSubscription($event)))
    }, [
      _createElementVNode("option", _hoisted_2, _toDisplayString(_ctx.$t('allOrganizations')), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
        return (_openBlock(), _createElementBlock("option", {
          key: item.id,
          value: item.id
        }, _toDisplayString(item.organizationName), 9, _hoisted_3))
      }), 128))
    ], 32),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "dropdown-icon" }, [
      _createElementVNode("i", { class: "fas fa-angle-down" })
    ], -1))
  ]))
}